module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Fraværsanmodning")]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isShowTabs) ? _c('Tabs', {
    staticClass: "marg-1-bottom",
    attrs: {
      "selected": _vm.selectedTab,
      "tabs": [{
          id: 'request',
          title: 'Anmod om fravær'
        },
        {
          id: 'list',
          title: 'Dine fraværsanmodninger'
        }
      ]
    },
    on: {
      "select": function($event) {
        _vm.selectedTab = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'list') ? _c('UserRequestList', {
    attrs: {
      "isUserView": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'request') ? [(_vm.isMultipleSchoolsActive && !_vm.activeSchoolId) ? [_c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg skole")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSchoolId),
      expression: "activeSchoolId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChangeActiveSchoolId]
    }
  }, _vm._l((_vm.userSchoolsSorted), function(school) {
    return _c('option', {
      domProps: {
        "value": school.id
      }
    }, [_vm._v("\n                " + _vm._s(school.name) + "\n              ")])
  }), 0)])] : (_vm.activeSchoolId) ? [_c('div', {
    staticClass: "do-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })])] : [_c('UserAbsence', {
    attrs: {
      "resetCounter": _vm.resetAbsenceCounter
    },
    on: {
      "setSubject": _vm.setSelectedSubject
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('DatepickerRange', {
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.date
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time-changer__group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Tid")]), _vm._v(" "), _c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-group marg-1-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Evt. note")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "do-input",
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })])]] : _vm._e()], 2), _vm._v(" "), (_vm.selectedTab === 'request') ? _c('div', {
    staticClass: "d-modal__buttons d-modal__buttons__padding",
    staticStyle: {
      "padding": "1rem"
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.create')) + "\n      ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n      ")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59b2419b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRequests/UserRequest.vue
// module id = 1661
// module chunks = 1